import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const purchaseGiftCardLanguages = {
  pageTitle: "Give the Gift of Performing Arts!",
  mainCardTitle: "Share a Gift Card",
  mainCardDescription:
    "Share the magic of Place des Arts with a friend or loved one. Upon purchase of a gift card, a unique code will be generated for the intended recipient to redeem. Once redeemed, the gift card is not refundable.",
  amountTitle: "Gift Card Amount",
  recipientTitle: "Recipient",
  recipientEnabledDesc:
    "The recipient will be sent an email with the unique code for them to redeem their gift card. Once redeemed, the recipient will receive an account credit that they can use to purchase tickets for any show sold by the Place des Arts box-office.",
  recipientDisabledDesc:
    "If an intended recipient is not specified, once purchased, you will have to forward the unique code to the recipient. Upon your recipient receiving their gift card, they will be prompted to enter their unique code to redeem the gift card. Once redeemed, the recipient will receive an account credit that they can use to purchase tickets for all shows sold by the Place des Arts box-office.",
  purchaseGiftCardSuccessLanguage: "Your purchase was successful!",
};

export const redeemGiftCardLanguages = {
  pageTitle: "Give the Gift of Performing Arts!",
  mainCardTitle: "Redeem a Gift Card",
  mainCardLoggedInDesc:
    "Please input the case sensitive code provided to redeem the value of the gift card to the Hippodrome Broadway Series in Baltimore account above.",
  mainCardLoggedOutDesc:
    "Please input the case sensitive code provided to redeem the value of the gift card to the Hippodrome Broadway Series in Baltimore.",
  successDesc: "has been added to to your account!",
  redeemGiftCardButtonLanguage: "Use your Gift Card",
};

export const purchaseSeatsLanguages = {
  registerFormTitle: "Create an Account",
  saveCardSwitchLabel: "Save card for future purchases?",
};

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Click Get Started",
    description:
      "Click Get Started on your desktop, laptop, or mobile device to begin.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      "Connect your New York Rangers account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Games",
    description:
      "Select the games you wish to attend based on the amount of credit you have available.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description:
      "Tickets will be available in your Account Manager within 24 hours of redemption. Reach out to Live Fan Support for any questions.",
  },
];

export const faqs = [
  {
    title: "How does the New York Rangers program work?",
    description:
      "The New York Rangers Flex program allows fans to select any seat to any game. Simply log into your New York Rangers Account manager and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description:
      "No. You have the opportunity to select all the games you'd like to attend throughout the season. This is subject to change.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "How many tickets can I select for each game?",
    description:
      "Flex Plan customers are eligible to redeem up to 4 tickets per game.",
  },
  {
    title: "Where are event tickets delivered?",
    description:
      "Event tickets are delivered directly within your New York Rangers Account Manager within an hour of selection.",
  },
];

export const RegisterTerms = () => (
  <>
    By creating an account, you agree to the{" "}
    <Link
      href="https://www.attend.tech/terms-of-use"
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
    >
      Terms of Use
    </Link>{" "}
    and understand that information will be used as described in our{" "}
    <Link
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      href="https://www.attend.tech/privacy-policy"
    >
      Privacy Policy
    </Link>
    .
  </>
);

export const CheckoutTerms = () => (
  <>
    By purchasing, you agree to the{" "}
    <Link
      href="https://www.attend.tech/terms-of-use"
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
    >
      Terms of Use
    </Link>{" "}
    and understand that information will be used as described in our{" "}
    <Link
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      href="https://www.attend.tech/privacy-policy"
    >
      Privacy Policy
    </Link>
    .
  </>
);
